import {
  API_CIDADES,
  API_ENDERECOS,
  API_ENTIDADES,
  API_OPERADORES,
  API_PRODUTIVIDADE_OPERADORES,
  API_TIPOS_ENTIDADE,
  API_TREINAMENTOS,
  API_UF,
} from '../api/apiConfig';
import {
  Cidade,
  Endereco,
  Entidade,
  Operador,
  ProdutividadeOperador,
  TipoEntidade,
  Treinamento,
  UF,
} from '../types/pessoas';
import { createCrudService } from './crudFactory';

export const ufService = createCrudService<UF>(API_UF);
export const cidadesService = createCrudService<Cidade>(API_CIDADES);
export const enderecosService = createCrudService<Endereco>(API_ENDERECOS);
export const tiposEntidadeService =
  createCrudService<TipoEntidade>(API_TIPOS_ENTIDADE);
export const entidadesService = createCrudService<Entidade>(API_ENTIDADES);
export const operadoresService = createCrudService<Operador>(API_OPERADORES);
export const treinamentosService = createCrudService<Treinamento>(API_TREINAMENTOS);
export const produtividadeOperadorService =
  createCrudService<ProdutividadeOperador>(API_PRODUTIVIDADE_OPERADORES);
